import PropTypes from "prop-types";
import React from "react";

const Loading = ({ label = "Loading...", className = "text-center" }) => {
  return (
    <div className={className}>
      <i className="fa fa-spin fa-spinner" /> {label}
    </div>
  );
};

Loading.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;
